<template>
    <ul class="nav nav-tabs list_tabs btn-reports">
      <li
        class="nav-item list-item"
        v-for="lang in languages"
        :key="lang.code"
      >
        <button
          class="nav-link"
          :class="{ active: currentLang === lang.code }"
          @click="$emit('languageChanged', lang.code)"
        >
          {{ lang.label }}
        </button>
      </li>
    </ul>
  </template>
  
  <script>
  export default {
    name: "LanguageTabs",
    props: {
      languages: {
        type: Array,
        required: true
      },
      currentLang: {
        type: String,
        required: true
      }
    }
  };
  </script>
  